import moment from 'moment'

export default {
  namespaced: true,
  state: {
    remediationData: undefined
  },
  getters: {
    state: (state) => state
  },
  actions: {
    setRemediationData ({ commit }, remediationData) {
      commit('setRemediationData', remediationData)
    },
    sortRemediationNonChronological ({ state }) {
      state.remediationData.sort((a, b) => {
        return moment(b.dateRemediation, 'DD.MM.YYYY') - moment(a.dateRemediation, 'DD.MM.YYYY')
      })
    }
  },
  mutations: {
    setRemediationData (state, remediationData) {
      state.remediationData = remediationData
    }
  }
}
